import { createRequest } from "helpers/tools";

export const deleteTrackerConsents = async (id) => {
    return await createRequest({
        suffix: `trackers/consents/${id}`,
        method: "delete",
        handleError: false,
    });
};

export const deleteTrackerTestEvent = async (id) => {
    return await createRequest({
        suffix: `trackers/test-event-code/${id}`,
        method: "delete",
        handleError: false,
    });
};
